import { render, staticRenderFns } from "./r-sky-common-config-page.vue?vue&type=template&id=2e0f2343"
import script from "./r-sky-common-config-page.vue?vue&type=script&lang=js"
export * from "./r-sky-common-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0f2343')) {
      api.createRecord('2e0f2343', component.options)
    } else {
      api.reload('2e0f2343', component.options)
    }
    module.hot.accept("./r-sky-common-config-page.vue?vue&type=template&id=2e0f2343", function () {
      api.rerender('2e0f2343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/skyrace/r-sky-common-config-page.vue"
export default component.exports